import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/working_set_plans/Files.scss';
import { withRouter } from 'react-router';
import { __, dateTimeFrom, scrollToBottom } from '../../core/utils';
import * as _ from 'lodash';
import ReactDropzone from 'react-dropzone';
import classNames from 'classnames';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import autobind from 'autobind-decorator';
import { setNotification } from '../../redux/actions/general/notification';
import {
  listWorkingSetPlans,
  uploadPlanFiles,
} from '../../redux/actions/table/working_set_plans';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import FilePreview from '../../components/FilePreview';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import Dropdown from '../../components/Dropdown';
import { linkFilesToModel } from '../../redux/actions/table/files';

@withRouter
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showArchivedFiles: false,
    };
  }

  componentDidMount() {
    scrollToBottom(this.refs.scroll);
  }

  @autobind
  _handleDrop(acceptedFiles, rejectedFiles) {
    this.setState({ drag: false });

    const { data } = this.props;

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('working_set_plans.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('working_set_plans.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 104857600;
        })
      ) {
        setNotification({
          text: __('working_set_plans.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        setNotification(__('working_set_plans.files.upload.uploading'));

        uploadPlanFiles(data.id, acceptedFiles).then(() => {
          setNotification(__('working_set_plans.files.upload.uploaded'));

          this.props.match.params.stage &&
            listWorkingSetPlans(this.props.match.params.stage);

          this.props.readAction(data.id).then(() => {
            scrollToBottom(this.refs.scroll);
          });
        });
      }
    }
  }

  @autobind
  _downloadFile(row, download = false) {
    if (row.ext == 'pdf' && download == false) {
      window.open(row.stream_url, '_blank');
    } else {
      setNotification(__('working_set_plans.files.download.continue'));

      window.open(row.download_url, '_blank');
    }
  }

  @autobind
  _refreshPlan() {
    const { data } = this.props;

    return this.props.readAction(data.id).then(() => {
      scrollToBottom(this.refs.scroll);
    });
  }

  @autobind
  _openEditAttachment(row) {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'working_set_plan',
        plan_id: this.props.data.id,
      },
    });
  }

  @autobind
  _openUploadAttachmentVersion(row) {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'working_set_plan',
        plan_id: this.props.data.id,
      },
    });
  }

  @autobind
  _archiveAttachment(row) {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?',
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?',
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.',
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.',
                    ),
              );
              this._refreshPlan();
            });
          },
        },
      ],
    });
  }

  @autobind
  _deleteFile(row) {
    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'files.general.alert.want-delete-file-attachment-plan.process-cannot-undone',
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();

              setNotification(
                __('files.notification.selected-file-attachment-deleted-plan'),
              );

              this._refreshPlan();
            });
          },
        },
      ],
    });
  }

  @autobind
  _openLinkExistingFilesWizard() {
    const { data } = this.props;
    const stage_id = this.props.match.params.stage;

    hideDropdown();
    setAttachmentParams({
      link_existing_files_wizard: {
        stage_id,
        linked_file_ids: _.map(data.files, 'attachment_id'),
        onLinkFiles: (file_ids) =>
          linkFilesToModel(stage_id, 'Plan', data.id, file_ids).then(
            () => {
              this.props.readAction(data.id).catch(_.noop);
              listWorkingSetPlans(stage_id).catch(_.noop);
            }
          ),
      },
    });
  }

  @autobind
  _openUploadPicker() {
    hideDropdown();

    if (this.dropzone) {
      this.dropzone.open();
    }
  }

  render() {
    const { data, collapsed } = this.props;
    const can_manage_file =
      _.get(data, 'is_editor') && _.get(data, 'status') == '1';
    const files = _.sortBy(data.files, ['created_at']);
    const archivedFilesCount = _.size(_.filter(files, (file) => file.archived));
    const visibleFiles = this.state.showArchivedFiles
      ? files
      : _.filter(files, (file) => !file.archived);

    const lightbox_images = _.map(
      _.filter(visibleFiles, (file) =>
        _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext)),
      ),
      (file) => ({
        id: file.id,
        attachment_version_id: file.attachment_version_id,
        stream_url: file.stream_url,
        title: [file.name, file.ext].join('.'),
        download_url: file.download_url,
        ext: file.ext,
        width: file.width,
        height: file.height,
      }),
    );

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        {!_.isEmpty(files) && (
          <div className={styles.actions}>
            <label className={styles.showArchivedFiles}>
              {archivedFilesCount > 0 ? (
                <>
                  <span>
                    {__('working_set_plans.files.show-hide-archived-files')}{' '}
                    {'(' + archivedFilesCount + ')'}
                  </span>
                  <input
                    type='checkbox'
                    checked={this.state.showArchivedFiles}
                    onChange={(e) =>
                      this.setState({ showArchivedFiles: e.target.checked })
                    }
                  />
                </>
              ) : (
                <span>{__('working_set_plans.files.no-archived-files')}</span>
              )}
            </label>
          </div>
        )}
        <div className={styles.scroller} ref='scroll'>
          {_.map(visibleFiles, (row) => {
            return (
              <div
                className={classNames(
                  styles.row,
                  row.archived && styles.archived,
                )}
                key={row.attachment_id || row.id}
              >
                <div className={styles.left}>
                  <FilePreview
                    onDownloadFile={this._downloadFile}
                    row={row}
                    lightbox_images={lightbox_images}
                  />
                </div>
                <div className={styles.right}>
                  <span className={styles.creator}>
                    {_.get(row, 'creator.name', row.created_by)}
                    {' · '}
                    {dateTimeFrom(
                      row.current_version_created_at || row.created_at,
                    )}
                  </span>
                  <div className={styles.icons}>
                    <AttachmentFileMenu
                      name={'working_set_plan_file_menu_' + row.attachment_id}
                      row={row}
                      canManageFile={can_manage_file}
                      canVersionFile={can_manage_file}
                      onDownloadFile={this._downloadFile}
                      onOpenEdit={this._openEditAttachment}
                      onOpenUploadVersion={this._openUploadAttachmentVersion}
                      onArchiveAttachment={this._archiveAttachment}
                      onDeleteFile={this._deleteFile}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {_.get(data, 'is_editor') && _.get(data, 'status') == '1' && (
          <ReactDropzone
            ref={(dropzone) => {
              this.dropzone = dropzone;
            }}
            className={classNames(
              styles.dropzone,
              _.get(this.state, 'drag') && styles.drag,
            )}
            disableClick
            onDrop={this._handleDrop}
            onDragOver={() => this.setState({ drag: true })}
            onDragLeave={() => this.setState({ drag: false })}
            multiple={true}
          >
            <UploadIcon />
            <span className={styles.dropTitle}>
              {__('dropzone.title.drop-your-file-here')}
            </span>
            <Dropdown
              portal
              top={28}
              right={0}
              name={'working_set_plan_add_files_' + data.id}
              wrapperClassName={styles.addFilesDropdownWrapper}
              dropdownClassName={styles.addFilesDropdown}
              content={
                <div className={styles.addFilesMenu}>
                  <div
                    className={styles.addFilesOption}
                    onClick={this._openLinkExistingFilesWizard}
                  >
                    {__('working_set_plans.files.browse-from-volum3')}
                  </div>
                  <div
                    className={styles.addFilesOption}
                    onClick={this._openUploadPicker}
                  >
                    {__('working_set_plans.files.upload-new')}
                  </div>
                </div>
              }
            >
              <span className={styles.dropSubtitle}>
                {__('working_set_plans.files.add-files')}
              </span>
            </Dropdown>
          </ReactDropzone>
        )}
        {/* {_.get(data, 'is_editor') && _.get(data, 'status') == '1' && (
          <ReactDropzone
            className={classNames(
              styles.dropzone,
              _.get(this.state, 'drag') && styles.drag,
            )}
            onDrop={this._handleDrop}
            onDragOver={() => this.setState({ drag: true })}
            onDragLeave={() => this.setState({ drag: false })}
            multiple={true}
          >
            <UploadIcon />
            <span className={styles.dropTitle}>
              {__('dropzone.title.drop-your-file-here')}
            </span>
            <span className={styles.dropSubtitle}>
              {__('dropzone.title.or-select')}
            </span>
          </ReactDropzone>
        )} */}
      </div>
    );
  }
}

export default Files;
